<nav class="navbar navbar-expand-xl box-shadow">
  <a class="navbar-brand">CODIUM E-TAX</a>
  <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation"
          (click)="toggleNav = !toggleNav">
    <!--<span class="navbar-toggler-icon"></span>-->
    <i class="fas fa-bars"></i>
  </button>

  <div class="collapse navbar-collapse" id="navbarSupportedContent" [ngbCollapse]="toggleNav">
    <ul class="navbar-nav mr-auto" *ngIf="requireToChangePassword"></ul>
    <ul class="navbar-nav mr-auto" *ngIf="!requireToChangePassword">
      <li class="nav-item">
        <a class="nav-link" routerLinkActive="active-li" *ngIf="isAdmin() || isUIH() || isAccountantAdmin() || isIT()"
           [ngStyle]="{'font-size': language === 'th' ? '14px': '15px'}"
           [routerLink]="['/dashboard']">{{'MENU.DASHBOARD' | translate}}</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" routerLinkActive="active-li" *ngIf="isAdmin() || isUIH() || isIT()"
           [ngStyle]="{'font-size': language === 'th' ? '14px': '15px'}"
           [routerLink]="['/dashboard-it']">{{'MENU.MONITORING' | translate}}</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" routerLinkActive="active-li" *ngIf="isAdmin() || isUIH() || isIT()"
           [ngStyle]="{'font-size': language === 'th' ? '14px': '15px'}"
           [routerLink]="['/import-data']">{{'MENU.IMPORT-DATA' | translate}}</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" routerLinkActive="active-li" *ngIf="isAdmin() || isIT()"
           [ngStyle]="{'font-size': language === 'th' ? '14px': '15px'}"
           [routerLink]="['/profile', 'list']">{{'MENU.MANAGE-USERS' | translate}}</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" routerLinkActive="active-li" *ngIf="isAdmin() || isIT()"
           [ngStyle]="{'font-size': language === 'th' ? '14px': '15px'}"
           [routerLink]="['/seller', 'manage']">{{'MENU.MANAGE-SELLER' | translate}}</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" routerLinkActive="active-li" *ngIf="isAccountant()"
           [ngStyle]="{'font-size': language === 'th' ? '14px': '15px'}"
           [routerLink]="['/document', 'upload']">{{'MENU.DOCUMENT-UPLOAD'| translate}}</a>
      </li>
     <li class="nav-item">
       <a class="nav-link" routerLinkActive="active-li" *ngIf="isAccountant()"
          [ngStyle]="{'font-size': language === 'th' ? '14px': '15px'}"
          [routerLink]="['/document', 'issue']">{{'MENU.DOCUMENTS-ISSUE'| translate}}</a>
     </li>
     <li class="nav-item">
       <a class="nav-link" routerLinkActive="active-li" *ngIf="isAccountant() "
          [ngStyle]="{'font-size': language === 'th' ? '14px': '15px'}"
          [routerLink]="['/customer', 'list']">{{'TEXT.CUSTOMER-INFORMATION'| translate}}</a>
     </li>
      <li class="nav-item">
        <a class="nav-link" routerLinkActive="active-li" *ngIf="isAccountant() || isAccountantAdmin()"
           [ngStyle]="{'font-size': language === 'th' ? '14px': '15px'}"
           [routerLink]="['/search']">{{'MENU.SEARCH' | translate}}</a>
      </li>
      <li class="nav-item" *ngIf="enabledCustomerRequest">
        <a class="nav-link" routerLinkActive="active-li" *ngIf="isAccountant() || isAccountantAdmin() || isAdmin()"
           [ngStyle]="{'font-size': language === 'th' ? '14px': '15px'}"
           [routerLink]="['/document-request']">{{'MENU.DOCUMENT-REQUEST'| translate}}</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" routerLinkActive="active-li" *ngIf="isAccountant() || isAccountantAdmin()"
           [ngStyle]="{'font-size': language === 'th' ? '14px': '15px'}"
           [routerLink]="['/taxReport']">{{'MENU.TAX-REPORT' | translate}}</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" routerLinkActive="active-li" *ngIf="isAccountant() || isAccountantAdmin()"
           [ngStyle]="{'font-size': language === 'th' ? '14px': '15px'}"
           [routerLink]="['/bulktaxReport']">{{'MENU.BULK-TAX-REPORT' | translate}}</a>
      </li>
      <!--      <li class="nav-item">-->
      <!--        <a class="nav-link" routerLinkActive="active-li" *ngIf="isUIH() || isAccountant() || isAccountantAdmin()" [routerLink]="['/taxB2P']">รายงานภาษีให้ B2P</a>-->
      <!--      </li>-->
      <li class="nav-item">
        <a class="nav-link" routerLinkActive="active-li" *ngIf="isAccountantAdmin()"
           [ngStyle]="{'font-size': language === 'th' ? '14px': '15px'}"
           [routerLink]="['/zipFile']">{{'MENU.DOWNLOAD-XML' | translate}}</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" routerLinkActive="active-li" *ngIf="isAccountantAdmin()"
           [ngStyle]="{'font-size': language === 'th' ? '14px': '15px'}"
           [routerLink]="['/submitToRd']">{{'MENU.SUBMIT-TO-RD' | translate}}</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" routerLinkActive="active-li" *ngIf="isAccountantAdmin()"
           [ngStyle]="{'font-size': language === 'th' ? '14px': '15px'}"
           [routerLink]="['/rdSendReport']">{{'MENU.RD-SUMMARY' | translate}}</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" routerLinkActive="active-li" *ngIf="isUIH()"
           [ngStyle]="{'font-size': language === 'th' ? '14px': '15px'}"
           [routerLink]="['/billing']">{{'MENU.BILLING' | translate}}</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" routerLinkActive="active-li" *ngIf="isAdmin() || isIT()"
           [ngStyle]="{'font-size': language === 'th' ? '14px': '15px'}"
           [routerLink]="['/historyLog']">{{'MENU.LOGS' | translate}}</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" routerLinkActive="active-li" *ngIf="isIT() || isAdmin()"
           [ngStyle]="{'font-size': language === 'th' ? '14px': '15px'}"
           [routerLink]="['/settings']">{{'MENU.SETTINGS' | translate}}</a>
      </li>
    </ul>
    <ul class="navbar-nav align-middle">
      <div ngbDropdown placement="bottom-right" id="userArea" class="d-inline-block align-middle text-white">
        <button class="btn p-0" id="dropdownBasic1" ngbDropdownToggle>
          <svg width="25px" height="25px" viewBox="0 0 30 30"
               xmlns="http://www.w3.org/2000/svg">
            <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="Nav" transform="translate(-1344.000000, -22.000000)" fill="#FFFFFF">
                <path d="M1351.2744,43.9996 C1351.3374,43.217 1351.6118,42.4764 1352.106,41.8464 C1352.8788,
                40.8566 1354.0338,40.2896 1355.2756,40.2896 L1358.5866,40.2896 C1359.3678,40.2896 1360.128,
                40.5178 1360.7846,40.9476 C1361.8402,41.6406 1362.4772,42.7718 1362.5738,44.008 C1360.933,
                45.0314 1359.0038,45.6334 1356.9318,45.6334 C1354.8542,45.6334 1352.9194,45.0286 1351.2744,
                43.9996 M1346.2288,34.9304 C1346.2288,29.0308 1351.0294,24.2288 1356.9318,24.2288 C1362.8328,
                24.2288 1367.6348,29.0308 1367.6348,34.9304 C1367.6348,37.7234 1366.5498,40.2602 1364.7928,
                42.1684 C1364.3224,40.816 1363.4264,39.6288 1362.186,38.8154 C1361.1122,38.1098 1359.8676,
                37.7374 1358.5866,37.7374 L1355.2756,37.7374 C1353.2414,37.7374 1351.3542,38.6614 1350.0928,
                40.2742 C1349.642,40.8524 1349.2976,41.488 1349.0624,42.1614 C1347.3082,40.2532 1346.2288,
                37.7192 1346.2288,34.9304 M1369.8622,34.9304 C1369.8622,27.8016 1364.062,22 1356.9318,
                22 C1349.8002,22 1344,27.8016 1344,34.9304 C1344,39.0744 1345.967,42.7606 1349.0092,
                45.1294 C1349.1436,45.289 1349.306,45.4206 1349.5034,45.499 C1351.6076,46.983 1354.1668,
                47.8622 1356.9318,47.8622 C1359.6968,47.8622 1362.2546,46.983 1364.3588,45.499 C1364.5562,
                45.4206 1364.72,45.289 1364.853,45.1294 C1367.8952,42.7606 1369.8622,39.0744 1369.8622,
                34.9304 M1356.92914,29.72338 C1358.14714,29.72338 1359.13974,30.71598 1359.13974,
                31.93398 C1359.13974,33.15198 1358.14714,34.14458 1356.92914,34.14458 C1355.71114,
                34.14458 1354.71854,33.15198 1354.71854,31.93398 C1354.71854,30.71598 1355.71114,
                29.72338 1356.92914,29.72338 M1356.92914,36.43918 C1359.41274,36.43918 1361.43434,
                34.41898 1361.43434,31.93398 C1361.43434,29.45038 1359.41274,27.42878 1356.92914,
                27.42878 C1354.44554,27.42878 1352.42394,29.45038 1352.42394,31.93398 C1352.42394,
                34.41898 1354.44554,36.43918 1356.92914,36.43918" id="Fill-3"></path>
              </g>
            </g>
          </svg>
        </button>
        <select class="form-control form-control-sm language-switcher" style="vertical-align: middle;
        width: auto; height: auto ;display: inline"
                (change)="changeLanguage()"
                [(ngModel)]="language">
          <option value="en">&nbsp;EN</option>
          <option value="th">&nbsp;TH</option>
        </select>
        <div ngbDropdownMenu aria-labelledby="dropdownBasic1">

          <div class="dropdown-item disabled" (click)="stopPropagation($event)">
            <div align="center">{{getUsername()}}</div>
            <div align="center">({{getRole()}})</div>
          </div>
          <div class="dropdown-divider"></div>
          <a class="dropdown-item pointer" [routerLink]="['/profile', 'password']">
            <div align="center">{{'MENU.CHANGE-PASSWORD' | translate}}</div>
          </a>
          <div class="dropdown-divider"></div>
          <a class="dropdown-item pointer" (click)="logout()">
            <div align="center">{{'MENU.SIGN-OUT' | translate}}</div>
          </a>

        </div>
      </div>
    </ul>
  </div>
</nav>



// WEBPACK FOOTER //
// /opt/app/src/app/core/navbar/navbar.component.html